let menuState = false;

export default function menuOpen(state = menuState, action) {
  switch (action.type) {
    case 'TOGGLE_MENU':
      state = action.payload;
      return state;
    case 'CLOSE_MENU':
      state = false;
      return state;
    default:
      return state
  }
}